export { default as StudyList } from "./vue/study-list.vue";
export * from "./ts/IStudyList";